import { Suspense } from "react";

import { useDialog } from "~/src/modules/ui-kit";

import ComponentCard from "./ComponentCard";
import ComponentDetail from "./ComponentDetail";


export default function Component(props) {
    const { onChange, onRemove, ...componentProps } = props;

    const [Dialog, open, close] = useDialog();

    return (
        <Suspense>
            <ComponentCard
                { ...componentProps }
                onEdit={ open }
                onRemove={ onRemove }
            />
            <Dialog>
                <ComponentDetail
                    { ...componentProps }
                    onChange={ onChange }
                    onClose={ close }
                />
            </Dialog>
        </Suspense>
    );
}
